export enum SurveyTag {
  MEDICATION_HISTORY = "medication-history",
  DIAGNOSIS = "diagnosis",
  PRESCRIBER_INFORMATION = "prescriber-information",
}

export const AVAILABLE_SURVEY_TAGS = [
  SurveyTag.MEDICATION_HISTORY,
  SurveyTag.DIAGNOSIS,
  SurveyTag.PRESCRIBER_INFORMATION,
];
